import request from '@/utils/requestUtil'

export function orderList(params) {
  return request({
    method: 'GET',
    url: '/order/list',
    params: params
  })
}

export function fetchCategoryTreeList() {
  return request({
    method: 'GET',
    url: '/product/categoryTreeList'
  })
}

export function fetchProductDetail(id) {
  return request({
    method: 'GET',
    url: '/product/detail/' + id
  })
}

export function returnApplyCreate(data) {
  return request({
    method: 'POST',
    url: '/returnApply/create',
    data
  })
}
export function productCategory(params) {
  return request({
    method: 'GET',
    url: '/product/category',
    params
  })
}

export function orderConfirmReceiveOrder(params) {
  return request({
    method: 'POST',
    url: '/order/confirmReceiveOrder',
    params
  })
}

// 根据ID获取订单状态
export function orderGetOrderStatus(orderId) {
  return request({
    method: 'GET',
    url: '/order/getOrderStatus/' + orderId
  })
}
// 根据ID获取订单详情
export function orderGetDetail(orderId) {
  return request({
    method: 'GET',
    url: '/order/detail/' + orderId
  })
}

// 根据name删除上传凭证
export function orderDeleteVoucher(id) {
  return request({
    method: 'DELETE',
    url: '/order/deleteVoucher?idList=' + id
  })
}

// 取消订单
export function orderCancelUserOrder(params) {
  return request({
    method: 'POST',
    url: '/order/cancelUserOrder',
    params
  })
}

// 删除订单
export function orderDeleteOrder(params) {
  return request({
    method: 'POST',
    url: '/order/deleteOrder',
    params
  })
}

// 获取指定物流信息
export function orderLogistics(data) {
  return request({
    url: '/order/logistics',
    method: 'post',
    data
  })
}

// 结合爱购根据结算订单编号查询数据
export function orderParentOrderSn(OrderSn) {
  return request({
    method: 'GET',
    url: '/order/parent?parentOrderSn=' + OrderSn
  })
}

// 获取订单数量
export function orderCount() {
  return request({
    method: 'GET',
    url: '/order/count'
  })
}

// 获取主收款公司
export function mainUmsOperator(params) {
  return request({
    method: 'GET',
    url: '/order/mainUmsOperator',
    params
  })
}
